/** Play chart entrance animation once when the block scrolls into view. */
export default {
  data() {
    return {
      chartInView: false,
      animationPlayKey: 0,
      dataRevision: 0,
    };
  },
  mounted() {
    this.$nextTick(() => this.observeChartViewport());
  },
  beforeDestroy() {
    if (this._chartIo) {
      this._chartIo.disconnect();
      this._chartIo = null;
    }
  },
  methods: {
    observeChartViewport() {
      const el = this.$refs.chartViewport;
      const target = el && el.$el ? el.$el : el;
      if (!target || typeof target.getBoundingClientRect !== "function") {
        this.playChartAnimation();
        return;
      }
      if (typeof IntersectionObserver === "undefined") {
        this.playChartAnimation();
        return;
      }
      this._chartIo = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this.playChartAnimation();
            this._chartIo.disconnect();
            this._chartIo = null;
          }
        },
        { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
      );
      this._chartIo.observe(target);
    },
    playChartAnimation() {
      if (this.chartInView) return;
      this.chartInView = true;
      this.animationPlayKey += 1;
    },
    bumpChartData() {
      this.dataRevision += 1;
      if (this.chartInView) {
        this.animationPlayKey += 1;
      }
    },
    apexStaggerAnimation(barDelay = 120) {
      return {
        enabled: true,
        easing: "easeinout",
        speed: 1400,
        animateGradually: {
          enabled: true,
          delay: barDelay,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 650,
        },
      };
    },
    chartRenderKey() {
      return `dash-chart-${this.animationPlayKey}-${this.dataRevision}`;
    },
  },
};
